var Component = require("!../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./IsrsParcelNumberContainer.vue"),
  /* template */
  require("!!../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-0140ef0b\"}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./IsrsParcelNumberContainer.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./client/components/IsrsParcelNumberContainer.vue
// module id = 881
// module chunks = 1